// extracted by mini-css-extract-plugin
export default {"container":"Note_container__yy7E1","note":"Note_note__41Fy4","date":"Note_date__s6Xw+"};